import type { BluffGamePayload } from "./answerBluffGamePayload";
import type { ModeQuickQuestionRow } from "../types/api";

/** Map server `reason` codes on answer ack to user-facing copy. */
export function bluffAnswerRejectReasonMessage(reason: string | undefined, t: (key: string) => string): string {
  if (reason === "cannot_submit_truth") return t("party.joinBluff.cannotSubmitTruth");
  if (reason && reason.trim().length > 0) return reason;
  return t("party.joinBluff.answerRejected");
}

/** Normalize for “same answer” checks (trim, NFC, collapse spaces, case-insensitive). */
export function normalizeBluffTruthCompare(s: string): string {
  let t = s.normalize("NFC").trim().replace(/\s+/g, " ");
  t = t.toLowerCase();
  return t;
}

export function bluffSubmissionMatchesTruth(userInput: string, canonicalTruth: string): boolean {
  const u = normalizeBluffTruthCompare(userInput);
  const t = normalizeBluffTruthCompare(canonicalTruth);
  return u.length > 0 && t.length > 0 && u === t;
}

/**
 * Canonical truth string for the active round: optional `canonical_answer` from the server
 * (for guests), else the host’s question deck matched by `current_question_id` or `round_index`.
 */
export function resolveBluffCanonicalTruth(deck: ModeQuickQuestionRow[] | undefined, game: BluffGamePayload | null): string | null {
  if (!game) return null;
  const fromServer = game.canonical_answer;
  if (typeof fromServer === "string") {
    const s = fromServer.trim();
    if (s) return s;
  }
  const rows = deck ?? [];
  if (rows.length === 0) return null;
  const sorted = [...rows].sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0));
  if (game.current_question_id != null) {
    const row = sorted.find((q) => q.id === game.current_question_id);
    const a = row?.answer?.trim();
    if (a) return a;
  }
  const idx = game.round_index >= 0 ? game.round_index : 0;
  const row = sorted[idx] ?? sorted[0];
  const a = row?.answer?.trim();
  return a || null;
}
